import { FC, useState } from 'react'
import cn from 'classnames'
import * as Tooltip from '@radix-ui/react-tooltip'
import { IconCircled } from 'components/features/pfm/IconCircled/IconCircled'
import * as styles from 'components/atoms/TooltipIcon/TooltipIcon.styl'
import { useThemeClassNames } from 'hooks/useClassNames'
import { Theme } from 'interfaces/component'
import { IS_MOBILE } from 'helpers/userAgentHelpers'

type TooltipProps =
  & Tooltip.TooltipProps
  & {
    content: string | React.ReactNode,
    theme?: Theme
    iconSlug?: string
    className?: string
  }

export const TooltipIcon: FC<TooltipProps> = (props) => {
  const {
    className,
    children,
    content,
    iconSlug = 'question',
    theme = 'satin',
  } = props

  const themeClassNames = useThemeClassNames(theme)

  const tooltipContent = content || children
  const [isOpen, setIsOpen] = useState(false)

  const rootProps = IS_MOBILE ? { open: isOpen } : {}
  const triggerProps = IS_MOBILE ? {
    onMouseEnter: () => setIsOpen(true),
    onMouseLeave: () => setIsOpen(false),
    onFocus: () => setIsOpen(true),
    onBlur: () => setIsOpen(false),
  } : {}

  return (
    <Tooltip.Root delayDuration={ 100 } { ...rootProps }>
      <Tooltip.Trigger className={ styles.icon } { ...triggerProps }>
        <IconCircled iconSlug={ iconSlug } theme={ theme } />
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          onMouseEnter={ () => setIsOpen(true) }
          className={ cn(styles.tooltip, themeClassNames, className) }
        >
          <p>{ tooltipContent }</p>
          <Tooltip.Arrow className={ cn(styles.arrow, themeClassNames) } role='arrow' />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  )
}

export default TooltipIcon
